<template>
  <div
    id="iq-sidebar"
    class="iq-sidebar"
  >
    <div id="sidebar-scrollbar">
      <nav class="iq-sidebar-menu">
        <CollapseMenu
          :items="sidebarMenus"
          :sidebar-group-title="true"
          :open="true"
        />
      </nav>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { core, APPNAME } from '@/config/pluginInit'
import { getSidebarMenus } from '@/router/navigation'

import CollapseMenu from '@/components/core/menus/CollapseMenu.vue'

export default {
  name: 'Sidebar',

  components: {
    CollapseMenu
  },

  data () {
    return {
      appName: APPNAME
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),

    sidebarMenus () {
      if (this.user) {
        return getSidebarMenus(this.user)
      }

      return []
    }
  },

  mounted () {
    core.smoothScrollbar()
  },

  methods: {
    toggleSidebar () {
      core.triggerSet()
    }
  }
}
</script>
